import { motion } from 'framer-motion';
import { Battery, ArrowRight, Zap } from 'lucide-react';

const fadeIn = { initial: { opacity: 0 }, whileInView: { opacity: 1 }, viewport: { once: true } };
const fadeInUp = { initial: { opacity: 0, y: 20 }, whileInView: { opacity: 1, y: 0 }, viewport: { once: true } };

export default function BackupPowerSection() {
  return (
    <section data-testid="backup-power-section" className="py-20 px-6 bg-zinc-900 text-white border-t-4 border-yellow-400">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <motion.p {...fadeIn} className="font-body text-xs uppercase tracking-[0.2em] text-yellow-400 mb-3">Specialized Division</motion.p>
            <motion.h2 {...fadeInUp} transition={{ duration: 0.5 }}
              className="font-heading text-3xl sm:text-4xl font-black tracking-tight uppercase leading-tight mb-4">
              Looking for Whole-Home Backup Power?
            </motion.h2>
            <motion.p {...fadeInUp} transition={{ duration: 0.5, delay: 0.1 }}
              className="font-body text-base text-white/60 leading-relaxed mb-8">
              Evolution Electric provides specialized generator, battery, and solar backup solutions through our dedicated backup-power division, <strong className="text-white">Generators of Nashville</strong>.
            </motion.p>

            <motion.div {...fadeInUp} transition={{ duration: 0.5, delay: 0.2 }} className="flex flex-col sm:flex-row gap-3">
              <a
                href="https://generatorsofnashville.com"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-yellow-400 text-black font-heading font-bold text-xs uppercase tracking-wider px-6 py-3 border border-yellow-400 hover:-translate-y-0.5 transition-transform"
                data-testid="backup-power-explore-link"
              >
                Explore Backup Power Options <ArrowRight className="w-3 h-3" />
              </a>
              <a
                href="https://generatorsofnashville.com/#quiz"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-transparent text-yellow-400 font-heading font-bold text-xs uppercase tracking-wider px-6 py-3 border border-yellow-400/40 hover:bg-yellow-400/10 transition-colors"
                data-testid="backup-power-quiz-link"
              >
                <Zap className="w-3 h-3" /> Take the Free 60-Second Quiz
              </a>
            </motion.div>
          </div>

          <motion.div {...fadeInUp} transition={{ duration: 0.5, delay: 0.15 }} className="grid grid-cols-2 gap-3">
            {[
              { name: 'Generac', desc: 'Whole-Home Standby' },
              { name: 'Tesla Powerwall', desc: 'Home Battery' },
              { name: 'EcoFlow', desc: 'Smart Batteries' },
              { name: 'Anker SOLIX', desc: 'Home Power' },
              { name: 'Jackery', desc: 'Portable + Home' },
              { name: 'Solar', desc: 'Rooftop PV Systems' },
            ].map(brand => (
              <div key={brand.name} className="border border-white/10 bg-white/5 p-4 hover:border-yellow-400/30 transition-colors">
                <Battery className="w-5 h-5 text-yellow-400 mb-2" />
                <p className="font-heading text-sm font-bold uppercase tracking-tight">{brand.name}</p>
                <p className="font-body text-xs text-white/40">{brand.desc}</p>
              </div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
}
